import {
    GET_ASSET_ITEM_STATUS_PURCHASE_DETAILS,
    SET_ASSET_ITEM_STATUS_PURCHASE_DETAILS,
    SET_IS_ASSET_ITEM_STATUS_PURCHASE_DETAILS_CALLED
} from "./AssetItemStatusPurchaseDetailType"

const getAssetItemStatusPurchaseDetails = (fleetDetailId: any) => ({
    type: GET_ASSET_ITEM_STATUS_PURCHASE_DETAILS,
    fleetDetailId
})

const setAssetItemStatusPurchaseDetails = (assetItemStatusPurchaseDetails: any) => ({
    type: SET_ASSET_ITEM_STATUS_PURCHASE_DETAILS,
    assetItemStatusPurchaseDetails: assetItemStatusPurchaseDetails
})

const SetIsAssetItemStatusPurchaseDetailsCalled = (fleetDetailId : any , isLoading : any) => {
    return {
        type: SET_IS_ASSET_ITEM_STATUS_PURCHASE_DETAILS_CALLED,
        fleetDetailId,
        isLoading: isLoading
      };
  }

export {
    getAssetItemStatusPurchaseDetails,
    setAssetItemStatusPurchaseDetails,
    SetIsAssetItemStatusPurchaseDetailsCalled
}